import statusIcon from "../assets/status.png";
import pedidos from "../utils/statusPedidos";
import { useEffect, useState } from "react";
import CustomStepperComponent from "./CustomStepperComponent";
import useOrdersStore from "../store/ordersStore";
import api from "../services/api";

const StatusHome = () => {
  const [selectedValue, setSelectedValue] = useState("");
  const { getAllOrders, orders, loading, error } = useOrdersStore();

  const [order, setOrder] = useState(null);
  const year = new Date().getFullYear();

  useEffect(() => {
    getAllOrders();
  }, [getAllOrders]);

  const handleSelectChange = async (e) => {
    try {
      const id = e.target.value;
      setSelectedValue(id);
      const res = await api.get(`/orders/${id}`);
      setOrder(res.data);
    } catch (error) {
      console.log(error);
      alert("Erro ao buscar status do pedido!");
    }
  };

  return (
    <div className="flex bg-[#F9F9F9] mt-2 p-2 justify-between">
      <div className="flex items-center">
        <img src={statusIcon} className="md:h-[50px] w-[50px]" alt="" />
        <div className="ml-6 md:ml-0">
          <div className="ml-4 md:ml-2 inline-block">
            <p className="md:text-sm text-xl pl-6 md:pl-3 text-boldGray opacity-80 font-bold text-center">
              Status do pedido
            </p>
            <form>
              <select
                className="border-none p-2 text-md bg-transparent w-[180px] font-bold text-boldGray opacity-90 text-center"
                value={selectedValue}
                onChange={handleSelectChange}
              >
                <option value="" disable hidden>
                  Selecione
                </option>
                {orders.map((item, index) => {
                  const optionLabel = `P00${index + 1}-${year}`;

                  return (
                    <option key={index} value={item.id} className="font-bold">
                      {optionLabel}
                    </option>
                  );
                })}
              </select>
            </form>
          </div>
        </div>
      </div>

      <div className="w-[75%]">
        <CustomStepperComponent key={order?.id} order={order} />
      </div>
    </div>
  );
};

export default StatusHome;
